<template>
  <div
    class="logo"
    :a="$store.getters['menu/test']"
    @click="goHome"
  >
    <img src="@/assets/menulogo.png" />
  </div>
</template>

<script>
import { getInfo } from "../utils/token";
export default {
  name: "logo",
  data() {
    return {
      info: {},
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
  computed: {
    logo() {
      if (this.info.logo == undefined || this.info.logo == "") {
        return "";
      }
      return this.GLOBAL.picUrl + this.info.logo;
    },
    tilte() {
      return this.info.name || "";
    },
  },
  mounted() {
    let info = getInfo();
    this.info = info.info;
  },
};
</script>

<style lang="scss" scoped>
.logo {
  cursor: pointer;
  text-align: center;
  padding-left: 15px;
  // padding-left: 50px;
  float: left;
  line-height: 60px;
  color: white;
  margin-right: 15px;
  img {
    float: left;
    height: 30px;
    position: relative;
    top: 15px;
    border-radius: 10px;
  }
  span {
    float: left;
    margin-left: 5px;
    color: #ff8f48;
    color: #fff;
    font-weight: bold;
  }
}
</style>